import { render, staticRenderFns } from "./delete-company-document.vue?vue&type=template&id=c0d12090&scoped=true&"
import script from "./delete-company-document.vue?vue&type=script&lang=js&"
export * from "./delete-company-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d12090",
  null
  
)

export default component.exports